export default function Loading(){

 return(

  <div className="loading">

   Loading...

  </div>

 )

}